Inputmask({ mask: '+7 (999) 999-99-99' }).mask('.js-mob')